export enum CheckoutErrorType {
  CHECKOUT_NOT_FOUND = 'CHECKOUT_NOT_FOUND',
}

export const checkoutErrorMessage: Record<string | CheckoutErrorType, string> =
  {
    [CheckoutErrorType.CHECKOUT_NOT_FOUND]:
      'チェックアウト情報が見つかりません',
  };
